import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Factory, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-alden-green-dark via-alden-green to-alden-green-light text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Start Your Mineral Water Business?
        </h2>
        <p className="text-xl mb-12 max-w-3xl mx-auto text-white/90">
          Get free consultation, detailed quotation and complete project guidance from our engineering team — 200+ plants delivered across India.
        </p>
        
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link to="/contact">
            <Button className="bg-white text-alden-green hover:bg-gray-100 py-6 px-10 text-lg font-semibold shadow-2xl">
              <Mail className="mr-2" />
              Get Project Quotation
            </Button>
          </Link>
          <a href="/downloads/alden-company-profile.pdf" download data-testid="download-company-profile">
            <Button className="bg-alden-navy hover:bg-alden-navy-light text-white py-6 px-10 text-lg font-semibold shadow-2xl">
              <Factory className="mr-2" />
              Download Company Profile
            </Button>
          </a>
          <a href="tel:+919351292512">
            <Button className="bg-green-500 hover:bg-green-600 text-white py-6 px-10 text-lg font-semibold shadow-2xl">
              <Phone className="mr-2" />
              Call: +91 93512 92512
            </Button>
          </a>
        </div>

        <div className="inline-block bg-white/10 backdrop-blur-sm px-8 py-4 rounded-xl">
          <p className="text-white/90 mb-2">Email us at:</p>
          <a href="mailto:info@aldentechnologies.in" className="text-xl font-bold hover:text-yellow-300 transition-colors block">
            info@aldentechnologies.in
          </a>
          <div className="flex flex-wrap justify-center gap-4 mt-3 text-sm text-white/80">
            <a href="tel:+919351292512" className="hover:text-yellow-300">+91 93512 92512</a>
            <a href="tel:+919351002512" className="hover:text-yellow-300">+91 93510 02512</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
